import { Heading2, ListItem, OrderedList, Paragraph } from "../../../../src/components/Markdown";
import * as React from 'react';
export default {
  Heading2,
  ListItem,
  OrderedList,
  Paragraph,
  React
};